import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactInformationToUsComponent } from './contact-information-to-us.component';
import { StaticMsgModule } from '@lib/pipes';
import { PhoneNumberModule } from '../../pipes/phone-number/phone-number.module';

@NgModule({
  declarations: [ContactInformationToUsComponent],
  imports: [CommonModule, StaticMsgModule, PhoneNumberModule],
  exports: [ContactInformationToUsComponent],
})
export class ContactInformationToUsModule {}
